import BlockHeading from '@/_application/core/components/commons/block-heading';
import {Keywords} from '__generated__/__types__';
import {useTranslation} from 'next-i18next';
import {PopularKeywordsItem} from '@/_application/core/components/commons/popular-keywords/popular-keywords-item';
import cn from 'classnames';

interface PopularKeywordsProps {
    hashTags: Keywords[];
    className?: string;
    /**
     * Pre-translated title for ISR compatibility.
     * If provided, this will be used instead of calling useTranslation.
     * This ensures consistent rendering between server and client.
     */
    title?: string;
}

function PopularKeywords({hashTags, className, title}: Readonly<PopularKeywordsProps>) {
    const {t} = useTranslation('common');
    const displayTitle = title ?? t('popular-keyword', 'Từ khóa được tìm kiếm nhiều');

    if (!hashTags?.length) return null;

    return (
        <div className={cn('bg-white md:bg-transparent', className)}>
            <div className="flex h-10 content-center items-center justify-start py-2 pl-4 md:hidden">
                <h3 className="text-sm font-bold text-primary">{displayTitle}</h3>
            </div>

            <div className="px-4 pb-5 pt-1 md:mt-5 md:bg-inherit md:px-0 md:pb-0 md:pt-0">
                <div className="hidden md:block">
                    <BlockHeading name={displayTitle} />
                </div>

                <div className="h-px w-full bg-KPZ_divider md:block" />
                {hashTags.map((item: Keywords, index: number) => (
                    <PopularKeywordsItem
                        key={`${item.tag_url}${item.tag_name}${index}`}
                        tag_url={item.tag_url}
                        tag_name={item.tag_name}
                    />
                ))}
            </div>
        </div>
    );
}

export default PopularKeywords;
